import { render } from "./ImportMetrics.vue?vue&type=template&id=d197ccec"
import script from "./ImportMetrics.vue?vue&type=script&lang=js"
export * from "./ImportMetrics.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__